var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.000000pt",
    height: "17.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000,24.000000) scale(0.090000,-0.090000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 220 c-34 -8 -51 -24 -51 -48 0 -10 4 -9 16 2 8 9 24 16 35 16 17 0 19 -5 13 -37 -3 -21 -17 -58 -30 -82 -18 -33 -21 -47 -13 -57 21 -25 47 2 54 54 16 125 15 122 41 122 24 0 24 -1 18 -64 -8 -78 -1 -112 25 -119 25 -6 57 16 64 44 5 20 5 20 -14 3 -18 -16 -21 -16 -35 -2 -12 12 -14 28 -8 77 6 59 7 61 36 61 23 0 29 4 26 18 -3 14 -15 17 -73 19 -39 1 -85 -2 -104 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPi);
export default __webpack_public_path__ + "static/media/pi.6469cf4fa888b8575153876955c0e41a.svg";
export { ForwardRef as ReactComponent };